export default __webpack_public_path__ + "static/media/adriana2-team.cb9b6f3e.png";